import { useEffect, useState } from "react"
import { addVerifyEmail, verifyEmail } from "../api/requests/auth"
import { SpinnerContainer } from "../components/common/SpinnerContainer"

import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import { Input } from "../components/form/Input"
import { PrimaryButton } from "../components/buttons/PrimaryButton"
import { useNavigate, useSearchParams } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { EmailVerificationToken } from "../interfaces/emailConfirmation"
import { isBefore } from "date-fns"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

export const EmailConfirmationPage: React.FC = () => {
    const [code, setCode] = useState<string>("");
    const [searchParams] = useSearchParams();
    const [tokenString, setTokenString] = useState("");
    const [decodedToken, setDecodedToken] = useState<EmailVerificationToken | undefined>(undefined);
    const [expiredToken, setExpiredToken] = useState(false);
    const [invalidCode, setInvalidCode] = useState(false);
    const [verifySuccess, setVerifySuccess] = useState(false);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const verificationToken = searchParams.get('verificationToken');
        if (verificationToken) {
            setTokenString(verificationToken);
            const decodedJwt = jwtDecode(verificationToken) as EmailVerificationToken;
            const tokenExp = new Date(decodedJwt.exp * 1000);
            if (!decodedJwt.exp) {
                return;
            }
            if (isBefore(tokenExp, new Date())) {
                setExpiredToken(true);
            } else {
                setDecodedToken(decodedJwt);
            }
        }
    }, [searchParams])

    const handleVerifyEmail = async () => {
        if (code.length <= 0) {
            return;
        }
        setLoading(true);
        setInvalidCode(false);
        try {
            if (decodedToken?.signup) {
                await verifyEmail({code: code}, tokenString!);
            } else {
                await addVerifyEmail({code: code, verificationToken: tokenString});
                navigate('/profile');
                return;
            }
            setVerifySuccess(true);
            setLoading(false);
        } catch (e) {
            setInvalidCode(true);
            setLoading(false);
        }
    }

    return (
        <div className="w-full h-full flex justify-center items-center overflow-hidden">
            <img className="absolute top-0 left-0 h-[90%] opacity-35 w-auto pointer-events-none" src={bg1} alt="" />
            <img className="absolute top-0 right-0 h-[50%] opacity-25 object-contain object-top w-auto pointer-events-none" src={bg3} alt="" />
            {
                verifySuccess ?
                <div className="w-[300px] lg:w-[350px] shadow-main bg-white rounded-xl p-10 flex">
                    <CheckCircleOutlineIcon style={{width: "40px", height: "40px"}} className="text-green-500 mr-2"/>
                    <div className="text-left font-semibold text-[18px]">Konto edukalt loodud, saate sisse logida.</div>
                </div>
                :
                <SpinnerContainer show={loading}>
                    <div className="flex flex-col z-10 mt-[60px] pb-10 justify-center">
                        {
                            decodedToken ?
                            <div className="w-[300px] lg:w-[350px] shadow-main bg-white rounded-xl p-10">
                                <div className="mb-4"><EmailOutlinedIcon style={{width: "70px", height: "70px"}} className="text-gray-500"/></div>
                                <div className="text-primary text-left font-semibold text-[18px] pb-8">Sinu emailile <b>{decodedToken.email}</b> on saadetud 6-kohaline kood.</div>
                                <Input value={code} onChange={(e) => setCode(e)} placeHolder="Sisesta kood" name="email_code"></Input>
                                <div className="flex max-w-[140px] pt-3 items-center">
                                        <PrimaryButton title={"Kinnita"} onClick={() => handleVerifyEmail()}/>
                                </div>
                                {invalidCode ?
                                <div className="text-red-500">Vale kood</div>:
                                <></>}
                            </div>
                            :
                            expiredToken ?
                            <div className="text-red-500 text-lg font-bold">{decodedToken!.signup ? "Kood on aegunud, looge konto uuesti" : "Kood on aegunud, verifitseerige email uuesti"}</div>
                            :
                            <></>
                        }
                    </div>
                </SpinnerContainer>
            }
        </div>
    )
}